import { createContext } from 'react';
import { UserConfigContextData } from './interfaces/userconfig-context-props.interface';

const UserConfigContext = createContext<UserConfigContextData>(
    {} as UserConfigContextData,
);

export default UserConfigContext;
